module.exports = __webpack_public_path__ + "img/stitching-fairy-2.7e2cb0d5.jpg";